import axios from 'axios';

// const BASE_URL = 'http://localhost:8787';
const BASE_URL = 'https://hpc-api.huazai.io';

// 创建 axios 实例
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000, // 30 秒超时
  headers: {
    'Content-Type': 'application/json',
  },
});

// 统一的响应处理函数
const handleResponse = (response) => {
  const {data} = response;
  if (!data.success) {
    // 显示 toast 消息 3 秒
    // showToast(data.message || '操作失败', 3000);
    throw new Error(data.message || '操作失败');
  }
  return data.data;
};

// 封装 API 请求函数
const request = async (method, url, data = null) => {
  const config = {method, url};
  if (data) {
    config.data = data;
  }
  const response = await api(config);
  return handleResponse(response);
};

// API 函数
export const checkActivationCode = async code => {
  return request('get', `/activation/check/${code}`);
};

export const activateCode = async code => {
  return request('post', `/activation/activate/${code}`);
};

export const getMemberInfo = async code => {
  return request('get', `/activation/member/${code}`);
};
